<template>
  <div class="main-banner">
    <div class="main-banner-cont">
      <div class="banner-title">
        <div class="logo-box-wrap">
          <img
            src="../assets/img/main/kgf-donghaeng-logo.svg"
            alt="KOREA GRAND FESTIVAL, 동행축제 로고"
          />
        </div>
        <div class="sub-box">
          <div class="sub">
            <span class="date">축제기간 2026. 10. 29(목) ~ 11. 15(일)</span>
            <span class="txt"
              >동행축제 홈페이지는 현재 가오픈 중이며, 미공개 콘텐츠는 순차적으로
              공개될 예정입니다.</span
            >
            <span class="txt">정식오픈일ㅣ 10월 29일(목)</span>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-wrapper">
      <div class="lt">
        <div
          v-if="banners && banners.length > 0"
          ref="bannerSwiper"
          :class="[
            'swiper',
            'banner-component',
            banners ? `banner-count-${banners.length}` : '',
          ]"
        >
          <!-- 슬라이드 내용 -->
          <div class="swiper-wrapper">
            <div v-for="(item, idx) in banners" :key="idx" class="swiper-slide">
              <component
                :is="
                  isInternalRoute(item.mvmnptUrl, item.urlType)
                    ? 'router-link'
                    : 'a'
                "
                :to="
                  isInternalRoute(item.mvmnptUrl, item.urlType)
                    ? getInternalPath(item.mvmnptUrl)
                    : undefined
                "
                :href="
                  !isInternalRoute(item.mvmnptUrl, item.urlType) &&
                  !isPlaceholderExternal(item.mvmnptUrl, item.urlType)
                    ? getExternalUrl(item.mvmnptUrl)
                    : undefined
                "
                :class="[
                  'banner-slide-link',
                  {
                    'external-link':
                      !isInternalRoute(item.mvmnptUrl, item.urlType) &&
                      !isPlaceholderExternal(item.mvmnptUrl, item.urlType),
                  },
                ]"
                :title="
                  isInternalRoute(item.mvmnptUrl, item.urlType) ||
                  isPlaceholderExternal(item.mvmnptUrl, item.urlType)
                    ? undefined
                    : '새창으로 바로가기'
                "
                :target="
                  isInternalRoute(item.mvmnptUrl, item.urlType) ||
                  isPlaceholderExternal(item.mvmnptUrl, item.urlType)
                    ? undefined
                    : '_blank'
                "
              >
                <div class="banner-slide-content">
                  <div class="banner-image">
                    <img
                      :src="getSafeImageUrl(item.imgPtUrl)"
                      :alt="item.bannrTit || 'Banner'"
                    />
                  </div>
                </div>
              </component>
              <!-- 링크가 없는 경우를 위한 대체 div -->
              <div v-if="!item.mvmnptUrl" class="banner-slide-content">
                <div class="banner-image">
                  <img
                    :src="getSafeImageUrl(item.imgPtUrl)"
                    :alt="item.bannrTit || 'Banner'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <in-ready v-else />
        <div class="navi-wrap" v-if="banners && banners.length > 1">
          <div>
            <div class="swiper-pagination lt-swiper-pagination"></div>
            <!-- 컨트롤 버튼 (배너가 있을 때만 표시) -->
            <div v-if="banners && banners.length > 0" class="swiper-controls">
              <button
                type="button"
                class="swiper-button-prev"
                :disabled="!isSwiperReady"
                @click="goToPrevSlide"
              >
                이전
              </button>
              <button
                type="button"
                :disabled="!isSwiperReady"
                @click="togglePlay"
                :class="[
                  'swiper-button-play-control',
                  playing ? 'is-playing' : 'is-paused',
                ]"
              >
                {{ playing ? "정지" : "재생" }}
              </button>
              <button
                type="button"
                class="swiper-button-next"
                :disabled="!isSwiperReady"
                @click="goToNextSlide"
              >
                다음
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="rt">
        <div class="video-full-box">
          <iframe
            :src="videoUrl"
            title="동행축제 홍보 영상"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { ACT_GET_BANNER_LIST } from "../store/_act_consts";
import { getCheckItems } from "../assets/js/utils";
import {
  MUT_SET_BANNERS,
  MUT_SET_LAST_BANNER_INDEX,
  MUT_SHOW_ALERT,
} from "../store/_mut_consts";
import InReady from "@/components/common/InReady";
import Swiper from "swiper";
import ApiService from "../assets/js/api.service";

export default {
  name: "Banner",
  components: { InReady },
  data: () => ({
    resizeTimer: null,
    swiperInstance: null,
    videoSwiperInstance: null,
    activeSlideIndex: 0,
    playing: true,
    isSwiperReady: false,
    rtSwiperInstance: null,
    rtActiveSlideIndex: 0,
    rtPlaying: true,
    isRtSwiperReady: false,
    serverTime: null,
    videoUrl:
      "https://www.youtube.com/embed/uuPd_G8TJXc?autoplay=1&mute=1&loop=1&playlist=uuPd_G8TJXc",
    videoUrls: [
      "https://www.youtube.com/embed/uuPd_G8TJXc?autoplay=1&mute=1&loop=1&playlist=uuPd_G8TJXc",
    ],
    swiperOptions: {
      slidesPerView: 1,
      /* centeredSlides: true, */
      /* spaceBetween: 20, */
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".lt .swiper-pagination",
        dynamicBullets: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          /* spaceBetween: 0, */
        },
        901: {
          slidesPerView: 1,
          /* spaceBetween: 12, */
          loopAdditionalSlides: 1,
        },
        1161: {
          slidesPerView: 1,
        },
      },
    },
  }),
  computed: {
    ...mapGetters("main", ["banners", "bannerExpired", "lastBannerIndex"]),
    isMobile() {
      return window.innerWidth <= 800;
    },
    paginationType() {
      return this.isMobile ? "bullets" : "fraction";
    },
    dDayText() {
      if (!this.serverTime) return "";
      const targetDate = new Date("2026-04-11T00:00:00");
      const today = new Date(this.serverTime);
      const targetDateOnly = new Date(
        targetDate.getFullYear(),
        targetDate.getMonth(),
        targetDate.getDate(),
      );
      const todayOnly = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
      );
      const diffTime = targetDateOnly - todayOnly;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // 5일전부터 1일전까지만 일수 반환
      if (diffDays > 0 && diffDays <= 5) {
        return `${diffDays}`;
      } else {
        return "";
      }
    },
  },
  watch: {
    banners(newBanners) {
      if (newBanners && newBanners.length > 0) {
        this.$nextTick(() => {
          if (this.swiperInstance && !this.swiperInstance.destroyed) {
            this.swiperInstance.update();
          } else {
            this.initializeSwiper();
          }

          if (this.rtSwiperInstance && !this.rtSwiperInstance.destroyed) {
            this.rtSwiperInstance.update();
          } else {
            // this.initializeRtSwiper();
          }
        });
      } else if (this.swiperInstance && !this.swiperInstance.destroyed) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
        this.isSwiperReady = false;
      }

      if (this.rtSwiperInstance && !this.rtSwiperInstance.destroyed) {
        this.rtSwiperInstance.destroy(true, true);
        this.rtSwiperInstance = null;
        this.isRtSwiperReady = false;
      }
    },
  },
  async created() {
    // 서버 시간 가져오기
    try {
      const timeRes = await ApiService.query("/v1/app/common/time");
      if (timeRes && timeRes.serverTime) {
        this.serverTime = timeRes.serverTime;
      } else {
        this.serverTime = new Date().getTime();
      }
    } catch (e) {
      console.error("[Banner] Error fetching server time:", e);
      this.serverTime = new Date().getTime();
    }

    if (
      !this.banners ||
      this.banners.length === 0 ||
      new Date().getDate() > this.bannerExpired
    ) {
      try {
        const res = await this.getBannerList();
        const bannerItems = getCheckItems(res);
        if (Array.isArray(bannerItems)) {
          await this.$store.commit(`main/${MUT_SET_BANNERS}`, bannerItems);
        } else {
          console.error("[Banner] Invalid banner items received:", res);
          await this.$store.commit(`main/${MUT_SET_BANNERS}`, []);
        }
      } catch (error) {
        console.error(
          "[Banner] Error fetching banner list in created hook:",
          error,
        );
        await this.$store.commit(`main/${MUT_SET_BANNERS}`, []);
      }
    } else {
      console.log("[Banner] Using existing banner data from store.");
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeSwiper();

      this.initializeRtSwiper();
    });

    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);

    if (this.swiperInstance && !this.swiperInstance.destroyed) {
      try {
        const currentIndex =
          this.swiperInstance.realIndex !== undefined
            ? this.swiperInstance.realIndex
            : this.swiperInstance.activeIndex;
        if (currentIndex >= 0) {
          // --- 뮤테이션 호출 수정: $store.commit 사용 ---
          this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, currentIndex);
        }
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
        this.isSwiperReady = false;
      } catch (error) {
        console.error("[Banner] Error during beforeDestroy:", error);
      }
    }

    if (this.videoSwiperInstance && !this.videoSwiperInstance.destroyed) {
      this.videoSwiperInstance.destroy(true, true);
      this.videoSwiperInstance = null;
    }

    if (this.videoSwiperInstance && !this.videoSwiperInstance.destroyed) {
      this.videoSwiperInstance.destroy(true, true);
      this.videoSwiperInstance = null;
    }

    if (this.rtSwiperInstance && !this.rtSwiperInstance.destroyed) {
      try {
        this.rtSwiperInstance.destroy(true, true);
        this.rtSwiperInstance = null;
        this.isRtSwiperReady = false;
      } catch (error) {
        console.error("[Banner] Error during RT Swiper destroy:", error);
      }
    }
  },
  methods: {
    handleBannerClick(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
        title: "10월 29일(목) 오픈 예정입니다.",
        rightNow: true,
      });
    },
    // mapMutations 제거 (직접 commit 사용)
    // ...mapMutations("main", [MUT_SET_BANNERS, MUT_SET_LAST_BANNER_INDEX]),

    getBannerList() {
      return this.$store.dispatch(`main/${ACT_GET_BANNER_LIST}`);
    },
    onClickEngInfo(e) {
      if (e) e.preventDefault();
      const targetDate = new Date("2026-04-11 00:00:00");
      const nowDate = new Date();
      if (nowDate < targetDate) {
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: "10월 29일(목) 오픈 예정입니다.",
          rightNow: true,
        });
      } else {
        this.$router.push("/en");
      }
    },
    onClickInfo(e) {
      this.$router.push("/ko/event/LinkedPage");
    },
    onClickProductInfo(e) {
      this.$router.push("/ko/ProductInfo");
    },
    async initializeSwiper() {
      const swiperParams = JSON.parse(JSON.stringify(this.swiperOptions));
      const isMobile = window.innerWidth <= 800;

      swiperParams.pagination = {
        el: ".lt-swiper-pagination",
        clickable: true,
        type: isMobile ? "bullets" : "fraction",
        dynamicBullets: false,
      };

      if (
        this.videoUrls &&
        this.videoUrls.length > 0 &&
        this.$refs.videoSwiper
      ) {
        if (this.videoSwiperInstance && !this.videoSwiperInstance.destroyed) {
          this.videoSwiperInstance.destroy(true, true);
          this.videoSwiperInstance = null;
        }
        this.videoSwiperInstance = new Swiper(this.$refs.videoSwiper, {
          slidesPerView: 1,
          loop: true,
          pagination: {
            el: ".rt .video-swiper-pagination",
            clickable: true,
            type: isMobile ? "bullets" : "fraction",
          },
          // transition 버그 방지를 위해 네이티브 navigation 설정을 빼고 커스텀 이벤트 처리
        });
      }

      if (
        !this.banners ||
        this.banners.length === 0 ||
        !this.$refs.bannerSwiper ||
        this.swiperInstance
      ) {
        return;
      }

      let newInstance = null;

      // 배너 개수에 맞춰 옵션 조정
      const bannerCount = this.banners.length;

      // 슬라이드가 부족할 때 스와이프 기능 비활성화 (PC 등에서 딱 맞게 떨어질 때)
      swiperParams.watchOverflow = true;

      if (bannerCount > 0) {
        if (swiperParams.slidesPerView > bannerCount) {
          swiperParams.slidesPerView = bannerCount;
        }
        if (swiperParams.breakpoints) {
          Object.keys(swiperParams.breakpoints).forEach((bp) => {
            if (swiperParams.breakpoints[bp].slidesPerView > bannerCount) {
              swiperParams.breakpoints[bp].slidesPerView = bannerCount;
            }
          });
        }

        // 배너가 1개일 때만 루프와 자동재생을 끕니다.
        if (bannerCount === 1) {
          swiperParams.loop = false;
          swiperParams.autoplay = false;
        }
      }

      try {
        if (!(this.$refs.bannerSwiper instanceof HTMLElement)) {
          throw new Error("bannerSwiper ref is not a valid HTMLElement");
        }

        newInstance = new Swiper(this.$refs.bannerSwiper, {
          ...swiperParams,
          on: {
            slideChange: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                const currentIndex =
                  this.swiperInstance.realIndex !== undefined
                    ? this.swiperInstance.realIndex
                    : this.swiperInstance.activeIndex;
                this.activeSlideIndex = currentIndex;

                // 이미지 로딩으로 인한 CSS transitionend 취소 버그(animating stuck)를 방지하기 위한 강제 복구 타이머
                setTimeout(() => {
                  if (
                    this.swiperInstance &&
                    !this.swiperInstance.destroyed &&
                    this.swiperInstance.animating
                  ) {
                    this.swiperInstance.animating = false;
                    if (this.playing && this.swiperInstance.autoplay) {
                      this.swiperInstance.autoplay.stop();
                      this.swiperInstance.autoplay.start();
                    }
                  }
                }, 500);
              }
            },
            click: (e) => {
              // Swiper 5.x passes only the click event to this handler
              // Use the created instance reference to access clickedSlide/Index
              this.onSwiperClick(this.swiperInstance || newInstance, e);
            },
            init: () => {
              console.log("[Banner] Swiper init callback executed.");
            },
            autoplayStop: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                console.log("[Banner] Autoplay stopped");
              }
            },
            autoplayStart: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                console.log("[Banner] Autoplay started");
              }
            },
            slideChangeTransitionEnd: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                const currentRealIndex =
                  this.swiperInstance.realIndex !== undefined
                    ? this.swiperInstance.realIndex
                    : this.swiperInstance.activeIndex;
                this.activeSlideIndex = currentRealIndex;
                // --- 슬라이드 변경 시에도 인덱스 저장 ---
                if (currentRealIndex >= 0) {
                  this.$store.commit(
                    `main/${MUT_SET_LAST_BANNER_INDEX}`,
                    currentRealIndex,
                  );
                }
              }
            },
          },
        });

        if (!newInstance || newInstance.destroyed) {
          throw new Error("Failed to create a valid Swiper instance");
        }

        this.swiperInstance = newInstance;

        await this.$nextTick();

        if (this.swiperInstance && !this.swiperInstance.destroyed) {
          this.isSwiperReady = true;

          // --- 로깅 추가: 스토어에서 읽어온 값 확인 ---

          const targetIndex = this.lastBannerIndex;
          let shouldStartAutoplay = this.playing;

          const initialIndex =
            this.swiperInstance.realIndex !== undefined
              ? this.swiperInstance.realIndex
              : this.swiperInstance.activeIndex;

          // --- 로깅 추가: 복원 조건 확인 ---

          if (
            targetIndex >= 0 &&
            targetIndex < this.banners.length &&
            targetIndex !== initialIndex
          ) {
            try {
              if (this.swiperOptions.loop) {
                if (typeof this.swiperInstance.slideToLoop === "function") {
                  this.swiperInstance.slideToLoop(targetIndex, 0, false);
                } else {
                  console.error("[Banner] slideToLoop not found");
                }
              } else {
                if (typeof this.swiperInstance.slideTo === "function") {
                  this.swiperInstance.slideTo(targetIndex, 0, false);
                } else {
                  console.error("[Banner] slideTo not found");
                }
              }
              this.activeSlideIndex = targetIndex;
            } catch (slideError) {
              console.error(
                `[Banner] Error during slideTo/Loop AFTER nextTick:`,
                slideError,
              );
              this.activeSlideIndex = initialIndex;
            }
          } else {
            this.activeSlideIndex = initialIndex;
          }

          if (shouldStartAutoplay && this.swiperInstance.autoplay) {
            if (!this.swiperInstance.autoplay.running) {
              this.swiperInstance.autoplay.start();
            } else {
              console.log("[Banner] Autoplay already running AFTER nextTick.");
            }
          } else if (shouldStartAutoplay) {
            console.warn(
              "[Banner] Autoplay could not be started AFTER nextTick.",
            );
          }
        } else {
          console.error(
            "[Banner] Swiper instance became invalid before operations in nextTick.",
          );
          this.isSwiperReady = false;
        }
      } catch (error) {
        console.error("[Banner] Failed to initialize Swiper:", error);
        this.isSwiperReady = false;
        if (this.swiperInstance) {
          try {
            this.swiperInstance.destroy(true, true);
          } catch (e) {}
          this.swiperInstance = null;
        } else if (newInstance) {
          try {
            newInstance.destroy(true, true);
          } catch (e) {}
        }
      }
    },

    async initializeRtSwiper() {
      if (!this.$refs.rtBannerSwiper) {
        return;
      }

      if (!this.banners || this.banners.length === 0) {
        return;
      }

      if (this.rtSwiperInstance && !this.rtSwiperInstance.destroyed) {
        this.rtSwiperInstance.update();
        return;
      }

      const isMobile = window.innerWidth <= 800;
      const bannerCount = this.banners.length;

      const rtSwiperOptions = {
        slidesPerView: 1,

        loop: bannerCount > 1,

        watchOverflow: true,

        autoplay:
          bannerCount > 1
            ? {
                delay: 4000,
                disableOnInteraction: false,
              }
            : false,

        pagination: {
          el: ".rt-swiper-pagination",
          clickable: true,
          type: isMobile ? "bullets" : "fraction",
          dynamicBullets: false,
        },

        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          901: {
            slidesPerView: 1,
            loopAdditionalSlides: 1,
          },
          1161: {
            slidesPerView: 1,
          },
        },

        on: {
          init: () => {
            console.log("[Banner] RT Swiper init");
          },

          slideChange: (swiper) => {
            if (!swiper || swiper.destroyed) return;

            this.rtActiveSlideIndex =
              swiper.realIndex !== undefined
                ? swiper.realIndex
                : swiper.activeIndex;
          },

          slideChangeTransitionEnd: (swiper) => {
            if (!swiper || swiper.destroyed) return;

            this.rtActiveSlideIndex =
              swiper.realIndex !== undefined
                ? swiper.realIndex
                : swiper.activeIndex;
          },

          autoplayStart: () => {
            this.rtPlaying = true;
          },

          autoplayStop: () => {
            this.rtPlaying = false;
          },

          click: (swiper, event) => {
            this.onRtSwiperClick(swiper, event);
          },
        },
      };

      try {
        const instance = new Swiper(this.$refs.rtBannerSwiper, rtSwiperOptions);

        if (!instance || instance.destroyed) {
          throw new Error("Failed to create RT Swiper instance");
        }

        this.rtSwiperInstance = instance;
        this.isRtSwiperReady = true;

        await this.$nextTick();

        if (
          this.rtPlaying &&
          this.rtSwiperInstance &&
          !this.rtSwiperInstance.destroyed &&
          this.rtSwiperInstance.autoplay
        ) {
          if (!this.rtSwiperInstance.autoplay.running) {
            this.rtSwiperInstance.autoplay.start();
          }
        }
      } catch (error) {
        console.error("[Banner] Failed to initialize RT Swiper:", error);

        this.isRtSwiperReady = false;

        if (this.rtSwiperInstance && !this.rtSwiperInstance.destroyed) {
          try {
            this.rtSwiperInstance.destroy(true, true);
          } catch (e) {}

          this.rtSwiperInstance = null;
        }
      }
    },

    onSwiperClick(swiper, event) {
      try {
        if (!swiper) return;
        const slideEl =
          swiper.clickedSlide ||
          (event && event.target && event.target.closest
            ? event.target.closest(".swiper-slide")
            : null);
        if (!slideEl) return;
        // 루프 모드에서는 data-swiper-slide-index로 원본 인덱스를 확인
        let realIdx = undefined;
        if (slideEl.getAttribute) {
          const attr = slideEl.getAttribute("data-swiper-slide-index");
          if (attr != null) {
            const parsed = parseInt(attr, 10);
            if (!isNaN(parsed)) realIdx = parsed;
          }
        }
        if (realIdx == null) {
          const ci =
            typeof swiper.clickedIndex === "number" ? swiper.clickedIndex : -1;
          realIdx =
            ci >= 0 && this.banners && this.banners.length > 0
              ? ci % this.banners.length
              : this.activeSlideIndex;
        }
        if (
          realIdx == null ||
          realIdx < 0 ||
          !this.banners ||
          !this.banners[realIdx]
        )
          return;
        const item = this.banners[realIdx];

        const url = item && item.mvmnptUrl;
        const isInternal = this.isInternalRoute(url, item && item.urlType);
        const isPlaceholder = this.isPlaceholderExternal(
          url,
          item && item.urlType,
        );

        // 인덱스 저장
        if (typeof realIdx === "number" && realIdx >= 0) {
          this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, realIdx);
        }

        // 분기 처리: 이벤트 기본 동작 제어는 케이스별로 다르게
        if (isPlaceholder) {
          if (event && typeof event.preventDefault === "function")
            event.preventDefault();
          if (event && typeof event.stopPropagation === "function")
            event.stopPropagation();
          this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
            title: "10월 23일(금) 오픈 예정입니다.",
            rightNow: true,
          });
          return;
        }

        if (isInternal) {
          // router-link가 이미 네비게이션을 처리하므로 여기서 중복 호출하지 않음
          return;
        }

        // 외부 정상 URL: 앵커 기본 동작( target="_blank" )에 맡기되, 앵커가 없으면 window.open
        const anchor =
          event && event.target && event.target.closest
            ? event.target.closest("a")
            : null;
        if (anchor) {
          // 기본 동작으로 새 탭 오픈. 여기서는 preventDefault 호출하지 않음.
          return;
        } else {
          // 앵커가 없을 때만 수동 오픈
          if (event && typeof event.preventDefault === "function")
            event.preventDefault();
          if (event && typeof event.stopPropagation === "function")
            event.stopPropagation();
          window.open(this.getExternalUrl(url), "_blank");
          return;
        }
      } catch (e) {
        console.error("[Banner] onSwiperClick error:", e);
      }
    },

    onRtSwiperClick(swiper, event) {
      try {
        if (!swiper) return;

        const slideEl =
          swiper.clickedSlide ||
          (event && event.target && event.target.closest
            ? event.target.closest(".swiper-slide")
            : null);

        if (!slideEl) return;

        let realIdx;

        const attr =
          slideEl.getAttribute &&
          slideEl.getAttribute("data-swiper-slide-index");

        if (attr != null) {
          const parsed = parseInt(attr, 10);

          if (!isNaN(parsed)) {
            realIdx = parsed;
          }
        }

        if (realIdx == null) {
          const clickedIndex =
            typeof swiper.clickedIndex === "number" ? swiper.clickedIndex : -1;

          realIdx =
            clickedIndex >= 0 && this.banners?.length
              ? clickedIndex % this.banners.length
              : this.rtActiveSlideIndex;
        }

        if (
          realIdx == null ||
          realIdx < 0 ||
          !this.banners ||
          !this.banners[realIdx]
        ) {
          return;
        }

        const item = this.banners[realIdx];
        const url = item.mvmnptUrl;

        const isInternal = this.isInternalRoute(url, item.urlType);

        const isPlaceholder = this.isPlaceholderExternal(url, item.urlType);

        this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, realIdx);

        if (isPlaceholder) {
          if (event?.preventDefault) {
            event.preventDefault();
          }

          if (event?.stopPropagation) {
            event.stopPropagation();
          }

          this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
            title: "10월 29일(목) 오픈 예정입니다.",
            rightNow: true,
          });

          return;
        }

        if (isInternal) {
          return;
        }

        const anchor = event?.target?.closest
          ? event.target.closest("a")
          : null;

        if (anchor) {
          return;
        }

        window.open(this.getExternalUrl(url), "_blank");
      } catch (error) {
        console.error("[Banner] onRtSwiperClick error:", error);
      }
    },

    handleItemNavigation(item, storeIndex, fallbackIndex) {
      if (!item) return;
      const url = item.mvmnptUrl;
      const isInternal = this.isInternalRoute(url, item.urlType);
      const indexToStore =
        typeof storeIndex === "number" && storeIndex >= 0
          ? storeIndex
          : fallbackIndex;
      if (typeof indexToStore === "number" && indexToStore >= 0) {
        this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, indexToStore);
      }
      // 외부 링크이고 URL이 'https://'인 경우, 팝업만
      if (!isInternal && url === "https://") {
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: "10월 23일(금) 오픈 예정입니다.",
          rightNow: true,
        });
        return;
      }
      if (isInternal) {
        const path = this.getInternalPath(url);
        this.$router.push(path);
      } else {
        window.open(this.getExternalUrl(url), "_blank");
      }
    },
    togglePlay() {
      if (
        !this.swiperInstance ||
        this.swiperInstance.destroyed ||
        !this.swiperInstance.autoplay
      ) {
        console.error(
          "[Banner] Swiper instance or autoplay module is not available or destroyed.",
        );
        return;
      }
      this.playing = !this.playing;
      if (this.playing) {
        this.swiperInstance.autoplay.start();
      } else {
        this.swiperInstance.autoplay.stop();
      }
    },
    goToPrevSlide() {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        // transition 버그로 인해 갇힌 상태라면 강제로 해제
        if (this.swiperInstance.animating) {
          this.swiperInstance.animating = false;
        }
        this.swiperInstance.slidePrev();
      }
    },
    goToNextSlide() {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        // transition 버그로 인해 갇힌 상태라면 강제로 해제
        if (this.swiperInstance.animating) {
          this.swiperInstance.animating = false;
        }
        this.swiperInstance.slideNext();
      }
    },

    toggleRtPlay() {
      if (
        !this.rtSwiperInstance ||
        this.rtSwiperInstance.destroyed ||
        !this.rtSwiperInstance.autoplay
      ) {
        return;
      }

      this.rtPlaying = !this.rtPlaying;

      if (this.rtPlaying) {
        this.rtSwiperInstance.autoplay.start();
      } else {
        this.rtSwiperInstance.autoplay.stop();
      }
    },

    goToRtPrevSlide() {
      if (this.rtSwiperInstance && !this.rtSwiperInstance.destroyed) {
        if (this.rtSwiperInstance.animating) {
          this.rtSwiperInstance.animating = false;
        }

        this.rtSwiperInstance.slidePrev();
      }
    },

    goToRtNextSlide() {
      if (this.rtSwiperInstance && !this.rtSwiperInstance.destroyed) {
        if (this.rtSwiperInstance.animating) {
          this.rtSwiperInstance.animating = false;
        }

        this.rtSwiperInstance.slideNext();
      }
    },

    goToVideoPrevSlide() {
      if (this.videoSwiperInstance && !this.videoSwiperInstance.destroyed) {
        if (this.videoSwiperInstance.animating) {
          this.videoSwiperInstance.animating = false;
        }
        this.videoSwiperInstance.slidePrev();
      }
    },
    goToVideoNextSlide() {
      if (this.videoSwiperInstance && !this.videoSwiperInstance.destroyed) {
        if (this.videoSwiperInstance.animating) {
          this.videoSwiperInstance.animating = false;
        }
        this.videoSwiperInstance.slideNext();
      }
    },
    goToSlide(index) {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        if (this.swiperOptions.loop) {
          this.swiperInstance.slideToLoop(index);
        } else {
          this.swiperInstance.slideTo(index);
        }
      }
    },
    getSafeImageUrl(url) {
      try {
        return url && url.startsWith("http")
          ? url
          : "/assets/default-banner.png";
      } catch (e) {
        console.error(`[Banner] Failed to load default image:`, e);
        return "";
      }
    },
    isInternalRoute(url, type) {
      if (!url) return false;
      // urlType이 1이면 내부 링크로 간주합니다.
      return type == 1 || type == "1";
    },
    getInternalPath(url) {
      if (!url) return undefined;
      try {
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
      } catch (e) {
        return url.startsWith("/") ? url : `/${url}`;
      }
    },
    getExternalUrl(url) {
      if (!url) return "#";
      if (/^(https?:\/\/|\/\/)/i.test(url)) {
        return url;
      }
      if (!url.startsWith("/") && url.includes(".")) {
        return `//${url}`;
      }
      return url;
    },
    isPlaceholderExternal(url, type) {
      if (this.isInternalRoute(url, type)) return false;
      if (!url) return true;
      const s = String(url).trim();

      return s === "https://";
    },
    handleResize() {
      clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        const isMobile = window.innerWidth <= 800;
        const newType = isMobile ? "bullets" : "fraction";

        // LT Banner Swiper
        if (this.swiperInstance && !this.swiperInstance.destroyed) {
          const currentType = this.swiperInstance.params?.pagination?.type;

          if (currentType !== newType) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
            this.isSwiperReady = false;
          }
        }

        // RT Banner Swiper
        if (this.rtSwiperInstance && !this.rtSwiperInstance.destroyed) {
          const currentType = this.rtSwiperInstance.params?.pagination?.type;

          if (currentType !== newType) {
            this.rtSwiperInstance.destroy(true, true);
            this.rtSwiperInstance = null;
            this.isRtSwiperReady = false;
          }
        }

        this.$nextTick(() => {
          if (!this.swiperInstance && this.banners && this.banners.length > 0) {
            this.initializeSwiper();
          }

          if (
            !this.rtSwiperInstance &&
            this.banners &&
            this.banners.length > 0
          ) {
            this.initializeRtSwiper();
          }
        });
      }, 200);
    },
  },
};
</script>

<style scoped>
.m-block {
  display: none;
}
.pc-block {
  display: block;
}
@font-face {
  font-family: "Gmarket Sans";
  font-weight: 700;
  font-display: swap;
  src: url("../assets/fonts/woff2/GmarketSansBold.woff2") format("woff2"),
    url("../assets/fonts/woff/GmarketSansBold.woff") format("woff");
}

@font-face {
  font-family: "Gmarket Sans";
  font-weight: 400;
  font-display: swap;
  src: url("../assets/fonts/woff2/GmarketSansMedium.woff2") format("woff2"),
    url("../assets/fonts/woff/GmarketSansMedium.woff") format("woff");
}
.main-banner {
  position: relative;
  margin: -100px auto 0;
  padding: 100px 0 42px;
  width: 100%;
  background: url("../assets/img/main/img-main-bg-09.svg") no-repeat top
    center/cover;
}
.main-banner .main-banner-cont {
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  max-width: 1368px;
}
.main-banner .banner-title {
  margin: 24px auto;
  padding: 0 24px;
  width: 100%;
  max-width: 1648px;
  min-height: 120px;
}
.main-banner .banner-title .logo-box-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.main-banner .banner-title .txt-box {
  position: relative;
  font-family: "Gmarket Sans";
  text-align: center;
  letter-spacing: -0.02em;
  line-height: 1.2;
  font-size: 50px;
  color: #333;
  font-weight: 300;
}
.main-banner .banner-title .txt-box strong {
  display: block;
  font-size: 90px;
  color: #01701f;
  font-weight: 700;
}
.main-banner .banner-title .txt-box strong span {
  color: #069d2f;
}
.main-banner .banner-title .txt-box .d-day-badge {
  display: block;
  position: absolute;
  top: -20px;
  right: -104px;
  border-radius: 50%;
  padding: 20px 0;
  width: 100px;
  height: 100px;
  font-family: var(--font-family-base);
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  vertical-align: middle;
  line-height: normal;
  letter-spacing: normal;
  background-color: #6dcc92;
  /* background-color: #FF5A5F; */
}
.main-banner .banner-title .txt-box .d-day-badge:before {
  position: absolute;
  left: 16px;
  bottom: -14px;
  content: "";
  width: 33px;
  height: 28px;
  background: url("../assets/img/main/ico-day-counter-shape.png") no-repeat
    center;
}
.main-banner .banner-title .txt-box .d-day-badge b {
  vertical-align: baseline;
  font-size: 36px;
}
.main-banner .banner-title .sub-box {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.main-banner .banner-title .sub {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  letter-spacing: 0;
  flex-direction: column;
}
.main-banner .banner-title .sub .txt {
  display: block;
  font-family: var(--font-family-base);
  text-indent: 0;
  font-size: clamp(16px, 2.1875vw, 28px);
  color: #333;
  font-weight: 600;
  text-align: center;
}
.main-banner .banner-title .sub .date {
  padding: 12px 24px;
  border-radius: 40px;
  font-size: clamp(16px, 2.1875vw, 20px);
  color: #6b4632;
  font-weight: 700;
  background: #f8e0c1;
}
.main-banner .banner-title .t-info {
  display: block;
  margin-top: 32px;
  text-align: center;
  font-family: var(--font-family-base);
  font-size: 26px;
  color: #666;
  font-weight: 700;
}
.main-banner .banner-title .btnEng {
  display: inline-block;
  position: absolute;
  right: 0;
  padding: 8px 24px;
  border-radius: 40px;
  font-size: 18px;
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  background: #40b7ee;
}

.main-banner .banner-title .left-btn-group {
  position: absolute;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.main-banner .banner-title .btnInfo {
  display: inline-block;
  padding: 8px 24px;
  border-radius: 40px;
  font-size: 18px;
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  background: #40b7ee;
}

.main-banner .banner-title .btnProductInfo {
  display: inline-block;
  padding: 8px 24px;
  border-radius: 40px;
  font-size: 18px;
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  background: #40b7ee;
}
.banner-wrapper {
  display: flex;
  gap: 40px;
  position: relative;
  max-width: 1368px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
}
.banner-wrapper .lt {
  display: block;
  position: relative;
  border-radius: 32px;
  flex: 1;
  width: 100%;
}
.banner-wrapper .rt {
  flex: 1;
  width: calc(50% - 20px);
}
.banner-wrapper .rt .video-full-box {
  position: relative;
  width: 100%;
  border-radius: 32px;
  overflow: hidden;
  aspect-ratio: 780 / 460;
  background: #000;
}
.banner-wrapper .rt .video-full-box iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
.banner-wrapper .rt .img-banner {
  display: block;
  overflow: hidden;
  border-radius: 32px;
  position: relative;
  height: 100%;
  aspect-ratio: 780/460;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.16);
}
.banner-wrapper .rt .img-banner img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}

.video-swiper {
  width: 100%;
  height: 100%;
}

.banner-component {
  flex: 1;
  margin: 0 auto;
  overflow: hidden;
  width: 100%;
  border-radius: 32px;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
  aspect-ratio: 780 / 460; /* 1개 노출 시에 맞게 비율 조정 */
  width: 100% !important;
}

.banner-slide-content {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.banner-slide-link {
  width: 100%; /* 2025-08-04  */
  height: 100%;
}
.banner-image {
  height: 100%;
}
.banner-image img {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}

.navi-wrap,
.video-navi-wrap {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}
.navi-wrap > div,
.video-navi-wrap > div {
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 180px;
  border-radius: 999px;
  border: 1px solid #ddd;
  background-color: #fff;
}
.video-swiper-pagination {
  display: flex;
  position: initial;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 50px;
  font-size: 18px;
  color: #1d1d1d;
}
/* 버튼 위치 조정 - 우측으로 배치 */
.swiper-controls {
  display: flex;
  height: 50px;
  z-index: 20;
  /* transform: translate(-50%, -50%); */
}
.swiper-button-prev,
.video-swiper-prev {
  left: 96px;
  background: url("../assets/img/main/btn-swiper-prev-02.svg") no-repeat center;
}
.swiper-button-next,
.video-swiper-next {
  right: 32px;
  background: url("../assets/img/main/btn-swiper-next-02.svg") no-repeat center;
}
.swiper-button-play-control {
  position: absolute;
  right: 56px;
  background: url("../assets/img/main/btn-swiper-play-control-02.svg") no-repeat
    center;
}
.swiper-button-play-control.is-paused {
  background: url("../assets/img/main/btn-swiper-play-on-control-02.svg")
    no-repeat center;
}
.swiper-button-prev,
.swiper-button-next,
.swiper-button-play-control,
.video-swiper-prev,
.video-swiper-next {
  position: initial;
  pointer-events: auto;
  margin-top: 0;
  width: 24px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: -9999px;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* pagination + pause 버튼 나란히 정렬 */
.pagination-control-group {
  margin: 20px -158px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.swiper-pagination {
  display: flex;
  position: initial;
  align-items: center;
  gap: 6px;
  height: 50px;
  font-size: 18px;
  color: #767676;
}

.swiper-pagination-fraction.swiper-pagination,
.swiper-pagination-fraction.video-swiper-pagination {
  width: auto !important;
}

.swiper-pagination-bullet {
  min-width: 12px !important;
  height: 12px !important;
  background: red;
}
/* 재생/정지 버튼 */
.btn-pause {
  position: absolute;
  right: -118px;
  bottom: 0;
  z-index: 21;
  width: 40px;
  height: 40px;
  border-top: 1px solid #c6c6c6;
  border-bottom: 1px solid #c6c6c6;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* 배너 개수가 1개 또는 2개일 때 가운데 정렬 및 화살표 숨김 (PC 기준) */
@media (min-width: 1161px) {
  .banner-count-1 .swiper-wrapper {
    justify-content: center !important;
  }
  .banner-count-1 + .swiper-controls .swiper-button-prev,
  .banner-count-1 + .swiper-controls .swiper-button-next {
    display: none !important;
  }
}

/* 버튼 비활성화 스타일 */
.swiper-button-prev:disabled,
.swiper-button-next:disabled,
.btn-pause:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 반응형 대응 */
/* 태블릿 */
@media (max-width: 1024px) {
  .banner-wrapper {
    gap: 30px;
  }
  .main-banner .banner-title .txt-box {
    font-size: 40px;
  }
  .main-banner .banner-title .txt-box strong {
    font-size: 68px;
  }
  .main-banner .banner-title .sub .date {
    padding: 10px 24px;
  }
  .navi-wrap > div,
  .video-navi-wrap > div {
    width: 160px;
  }
  .banner-wrapper .swiper-pagination,
  .banner-wrapper .video-swiper-pagination {
    height: 38px;
  }
  .banner-wrapper .swiper-controls {
    height: 38px;
  }
  .banner-wrapper .swiper-button-prev,
  .banner-wrapper .swiper-button-next,
  .banner-wrapper .swiper-button-play-control,
  .banner-wrapper .video-swiper-prev,
  .banner-wrapper .video-swiper-next {
    height: 38px;
  }
}

/* 모바일 */
@media (max-width: 800px) {
  .m-block {
    display: block;
  }
  .pc-block {
    display: none;
  }
  .main-banner {
    margin-top: -60px;
    padding: 60px 0 40px;
    background-image: url("../assets/img/main/img-main-bg-09-m.svg");
  }
  .banner-wrapper {
    flex-direction: column;
    gap: 20px;
    padding: 0 16px;
  }
  .main-banner .banner-title {
    padding: 0 16px;
    min-height: 100px;
  }

  .main-banner .banner-title .logo-box-wrap {
    gap: 36px;
    margin-bottom: 16px;
  }

  .main-banner .banner-title .txt-box {
    padding-top: 54px;
    font-size: 24px;
  }
  .main-banner .banner-title .txt-box strong {
    padding-top: 10px;
    line-height: 1;
    font-size: 50px;
  }
  .main-banner .banner-title .sub-box {
    margin-top: 6px;
  }
  .main-banner .banner-title .sub {
    flex-wrap: wrap;
    gap: 8px;
  }
  .main-banner .banner-title .sub .date {
    padding: 6px 10px;
  }
  .main-banner .banner-title .txt-box .d-day-badge {
    top: -4px;
    right: -6px;
    padding: 16px 10px;
    width: 60px;
    height: 60px;
    font-size: 11px;
  }
  .main-banner .banner-title .txt-box .d-day-badge:before {
    width: 21px;
    height: 19px;
    background-image: url("../assets/img/main/ico-day-counter-shape-m.png");
  }
  .main-banner .banner-title .txt-box .d-day-badge br {
    display: none;
  }
  .main-banner .banner-title .txt-box .d-day-badge b {
    font-size: 15px;
  }
  .main-banner .banner-title .t-info {
    margin-top: 20px;
    font-size: 16px;
  }
  .main-banner .banner-title .btnEng {
    position: fixed !important;
    top: 70px;
    right: 16px;
    padding: 6px 12px 6px 6px;
    font-size: 12px;
    z-index: 501;
  }
  .main-banner .banner-title .left-btn-group {
    position: fixed !important;
    top: 70px;
    left: 16px;
    z-index: 501;
  }

  .main-banner .banner-title .btnInfo,
  .main-banner .banner-title .btnProductInfo {
    padding: 6px 10px;
    font-size: 9px;
  }
  .navi-wrap,
  .video-navi-wrap {
    position: initial;
    margin-top: 6px;
    width: 100%;
    background: transparent;
  }
  .navi-wrap > div,
  .video-navi-wrap > div {
    width: auto;
    box-shadow: none;
    border: 0;
    background-color: transparent;
  }

  .banner-component {
    border-radius: 16px;
  }
  .banner-wrapper .swiper-pagination {
    position: relative;
    height: 24px;
    gap: 0 10px;
  }
  .banner-wrapper .pagination-control-group {
    gap: 4px;
    justify-content: center;
    margin-top: 8px;
  }
  .banner-wrapper .swiper-button-prev,
  .banner-wrapper .swiper-button-next {
    display: none;
  }
  .banner-wrapper .swiper-button-play-control {
    background-image: url("../assets/img/main/btn-swiper-play-control-02-m.svg");
  }
  .banner-wrapper .swiper-button-play-control.is-paused {
    background-image: url("../assets/img/main/btn-swiper-play-on-control-02-m.svg");
  }
  .banner-wrapper .swiper-controls {
    height: 24px;
  }
  .banner-wrapper .swiper-button-prev,
  .banner-wrapper .swiper-button-next,
  .banner-wrapper .swiper-button-play-control {
    height: 24px;
  }
  .btn-pause {
    position: initial;
    border: none;
    width: 36px;
    height: 36px;
  }
  .banner-wrapper .video-swiper-pagination {
    gap: 10px;
  }
  .video-navi-wrap > div {
    position: relative;
    gap: 0;
    padding: 0 34px;
  }
  .video-swiper-prev {
    position: absolute;
    top: 0;
    left: 0;
  }
  .video-swiper-next {
    position: absolute;
    top: 0;
    right: 0;
  }
  .banner-wrapper .lt {
    border-radius: 16px;
    width: 100%;
  }
  .banner-wrapper .rt {
    width: 100%;
  }
  .banner-wrapper .rt .video-full-box {
    border-radius: 16px;
  }
  .banner-wrapper .rt .img-banner {
    border-radius: 16px;
  }

  .main-banner .banner-title .sub .txt {
    max-width: 300px;
    line-height: 1.3;
  }
}
@media (max-width: 360px) {
  .main-banner .banner-title .sub {
    flex-direction: column;
    background: transparent;
  }
}
</style>
<style>
.banner-wrapper .swiper-pagination-current {
  color: #1d1d1d;
  font-weight: 700;
}
</style>
